module.exports = __webpack_public_path__ + "static/media/s2b2c-icon.0ac369fe.png";